export default "__VITE_ASSET__CLwWBsWp__"